import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReviewDetailsComponent } from '../review-details/review-details.component';
import { ModalService } from 'src/app/services/modal.service';
import { MustMatch } from 'src/app/validators/mustmatch.validator';

@Component({
  selector: 'app-create-scorer',
  templateUrl: './create-scorer.component.html',
  styleUrls: ['./create-scorer.component.scss']
})
export class CreateScorerComponent implements OnInit {

  form: FormGroup;

  emailPattern = /^([a-z0-9_\.\+-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/; // Uncommon Email Pattern

  constructor(
    private fb: FormBuilder,
    private modalService: ModalService
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      username: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
      password: ['', [Validators.required]],
      password_confirmation: ['', [Validators.required]],
      name: ['', [Validators.required]],
      status: ['', [Validators.required]],
      official: ['', [Validators.required]]
    }, {
      validator: MustMatch('password', 'password_confirmation')
    })
  }

  // createNewPlayer(){
  //   const payload = {
  //     username: this.username?.value,
  //     playerName: this.playerName?.value,
  //   }
  // }

  confirm() {
    const payload = {
      username: this.username?.value,
      email: this.email?.value,
      password: this.password?.value,
      password_confirmation: this.password_confirmation?.value,
      name: this.name?.value,
      status: this.status?.value,
      official: this.official?.value,
    };
    this.modalService.openReviewDetails(payload, 'create-scorer', {});
    // if (this.form.valid) {
    //   const modalRef = this.modalService.open(ReviewDetailsComponent, { centered: true });
    //   modalRef.componentInstance.reviewData = this.form.value; 
    //   this.close()
    //   modalRef.result.then((result) => {
    //     if (result === 'submit') {
    //       this.createNewPlayer();
    //     }
    //   });
    // } 
  }

  get username(){
    return this.form.get('username');
  }

  get email(){
    return this.form.get('email');
  }

  get password(){
    return this.form.get('password');
  }

  get password_confirmation(){
    return this.form.get('password_confirmation');
  }

  get name(){
    return this.form.get('name');
  }

  get status(){
    return this.form.get('status');
  }

  get official(){
    return this.form.get('official');
  }

  close(){
    this.modalService.hideCreateScorer();
  }
}
